'use client';

import { t } from 'i18next';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import { Button } from '@mui/material';

// import { SignInSchema } from 'src/utils/validations';

import { Form, Field } from 'src/components/hook-form';
import { useLocale } from 'src/locales';
import { createSchemas } from 'src/utils/use-validations';

export function Login({ open, onClose, submitLogin, loading }) {
  const { t } = useLocale();
  const { SignInSchema } = createSchemas();

  const defaultValues = {
    mobileNumber: '',
  };

  const methods = useForm({
    resolver: zodResolver(SignInSchema),
    defaultValues,
    mode: 'all',
  });

  const {
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { isSubmitting, isValid },
  } = methods;

  useEffect(() => {
    if (open) {
      reset();
    }
  }, [open, reset]);

  const onSubmit = handleSubmit(async (data) => {
    submitLogin({ mobileNumber: data.mobileNumber });
  });

  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <Field.Text name="mobileNumber" label={t('Mobile_Number')} required sx={{ my: 2 }} />

      <Button
        fullWidth
        color="primary"
        size="large"
        type="submit"
        variant="contained"
        loading={loading}
        disabled={isSubmitting || loading}
        sx={{
          '& .MuiCircularProgress-root': {
            color: '#0d9d57', // change loader colour here
            width: '20px !important',
            height: '20px !important',
          },
        }}
      >
        {t('Get_OTP')}
      </Button>
    </Form>
  );
}
